import React, { useEffect, useState } from 'react';
import './Home.css';

export default function Home({ language = 'en' }) {
  const [desc, setDesc] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/descriptions/00-Home.json')
      .then(res => res.json())
      .then(data => setDesc(data[0]));
  }, []);

  return (
    <section className="home-hero" id="home">
      <img
        className="home-hero-img"
        src={process.env.PUBLIC_URL + '/photos/07-StargazingViews/StargazingViews10-47-Large.jpg'}
        alt="Armonia House Hero"
      />
      <div className="home-hero-content">
        <h1>{desc && desc.title && desc.title[language]}</h1>
        <div className="home-hero-desc-placeholder">
          {desc ? (
            <p>{desc.description && desc.description[language]}</p>
          ) : (
            <p className="placeholder">[Enter your home description here]</p>
          )}
        </div>
      </div>
      <img
        className="home-secondary-img"
        src={process.env.PUBLIC_URL + '/photos/04-Garden/Garden04-24-Large.jpg'}
        alt="Garden"
      />
    </section>
  );
}
